import React, { useState } from 'react';
import { useEffect } from 'react';
import { useZettle } from '~Hooks';
import { RefundProps } from '../types';
import { gql, useMutation } from '@apollo/client';
import { RefundCrypto, RefundCryptoVariables } from './__queries__';
import QRCode from 'react-qr-code';

const REFUND_CRYPTO = gql`
  mutation RefundCrypto($transactionId: String!, $amount: Int!) {
    refundCryptoPayment(id: $transactionId, amount: $amount) {
      success
      message
      error
    }
  }
`;

export const CryptoRefund = (props: RefundProps) => {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const [refundCrypto] = useMutation<RefundCrypto, RefundCryptoVariables>(REFUND_CRYPTO);

  useEffect(() => {
    refundCrypto({
      variables: {
        transactionId: props.transactionId,
        amount: props.amount / 100,
      },
    })
      .then(({ data }) => {
        if (data?.refundCryptoPayment.success) {
          const redirectUrl = data?.refundCryptoPayment.message;

          if (redirectUrl) {
            // Show QR code
            setRedirectUrl(redirectUrl);
          } else {
            props.onCompleted();
          }
        } else {
          props.onFail(data?.refundCryptoPayment.error ?? 'Unknown error');
        }
      })
      .catch((e) => {
        props.onFail(e.message);
      });
  }, []);

  if (redirectUrl) {
    return <QRCode value={redirectUrl} />;
  }

  return null;
};
